/**
 * Culinary Service
 * Frontend wrapper for /api/v1/culinary/* (Wen-inspired techniques + plant recipe suggestions).
 */
import axios from 'axios';

// API base resolved via config/api.js so prod (REACT_APP_API_BASE_URL='') uses relative URLs through Nginx; localhost fallback only in dev.
import { API_BASE_URL as ROOT_API } from '../config/api';
const API_BASE_URL = `${ROOT_API}/api/v1`;

const culinaryService = {
  async listTechniques() {
    const response = await axios.get(`${API_BASE_URL}/culinary/techniques`);
    return response.data;
  },

  async getTechnique(techniqueType) {
    const response = await axios.get(`${API_BASE_URL}/culinary/techniques/${techniqueType}`);
    return response.data;
  },

  /**
   * List Wen-inspired cooking suggestions tied to a medicinal plant.
   * Returns { plant_id, scientific_name, current_month, suggestion_count, suggestions: [...] }
   * Each suggestion includes its technique inline.
   */
  async listSuggestionsForPlant(plantId, { inSeasonOnly = false } = {}) {
    const response = await axios.get(
      `${API_BASE_URL}/culinary/plant/${plantId}/suggestions`,
      { params: { in_season_only: inSeasonOnly } },
    );
    return response.data;
  },

  async getSuggestion(suggestionId) {
    const response = await axios.get(`${API_BASE_URL}/culinary/suggestions/${suggestionId}`);
    return response.data;
  },
};

export default culinaryService;
